export enum ContractedEnergyTypes {
  Real = 'Verklig',
  Charged = 'Debiterad årsenergi',
  Allowed = "Tillåten årsenergi"
}
